import { Injectable } from '@angular/core';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from 'cw-utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from 'app/decorators/environment.decorator';

@Injectable({
  providedIn: 'root'
})
export class IntegrationServiceService {

  @Environment("baseUrl") baseUrl!: string;


  constructor(public gw: ApiGateway, public snackBar: SnackBarService, private httpClient: HttpClient) { }

  requestAuthorizationSulAmerica(orderId: number, param?:any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.gw
        .post(`integration/sulamerica/request-authorization?orderId=${orderId}${param}`)
        .subscribe({
          next: (response) => resolve(response),
          error: (error) => reject(error),
        });
    });
  }

  checkStatusSulamerica(orderId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.gw
        .get(`integration/sulamerica/status/${orderId}`)
        .subscribe({
          next: (response) => resolve(response),
          error: (error) => reject(error),
        });
    });
  }

  checkEligibilitySulamerica(enrollment: string, insuranceId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.gw
        .get(`integration/sulamerica/eligibility?enrollment=${enrollment}&insuranceId=${insuranceId}`)
        .subscribe({
          next: (response) => resolve(response),
          error: (error) => reject(error),
        });
    });
  }

  sendDocumentSulamerica(orderId: number, params: any): Promise<any> {
    console.log('params', params);
    let url: string = '';
    let formData: FormData = new FormData();
    if (params) {
      url += `?typeDocument=${params.statusTypeDocumentId}`;
      if (params.idModelDocument) {
        url += `&idDocumentModel=${params.idModelDocument}`;
      }
      if (params.attachmentDocument) {

        formData.append('file', params.attachmentDocument, params.attachmentDocument.name);
      }
    }
    let authToken = localStorage.getItem('token');
    let headers = new HttpHeaders();
    headers = headers.append('X-Auth-Token', authToken);

    return new Promise((resolve, reject) => {
      this.httpClient
        .post(`${this.baseUrl}integration/sulamerica/send-document/${orderId}/${params.statusTypeDocumentId}`, formData, { headers: headers })
        .subscribe({
          next: (response) => {
            resolve(response)
          },
          error: (error) =>{
             reject(error)
          },
        });
    });

  }



}
